import * as React from 'react';
import {Card , Box,Typography } from '@mui/material';

export default function PaymentCompletePage()
{
    return (
        <>
            <Box textAlign="left">
                <Typography variant="h2" gutterBottom>Thank you</Typography>
                <Typography variant="h6" gutterBottom>Your payment has been successfully processed.</Typography>
            </Box>

            <Card>
                <Box p={5} textAlign="center">
                    <p>
                        We will send you a confirmation email of this payment and contact you again soon.
                        <br />
                        If you believe there has been an error please do not hesistate to contact us on.
                    </p>
                </Box>
            </Card>
        </>
    )
}